<template>
  <el-date-picker
    v-model="pickerValue"
    :type="type"
    :size="size"
    :readonly="readonly"
    :style="inlineStyle"
    range-separator="По"
    start-placeholder="Дата начала"
    end-placeholder="Дата окончания"
    format="dd-MM-yyyy HH:mm"
    :picker-options="pickerOptions"
  />
</template>

<script>
const userTimezone = new Date().getTimezoneOffset() * 60 * 1000;

export default {
  props: {
    value: {
      type: [String, Array, Date],
      required: false,
      default: null,
    },
    type: {
      type: String,
      default: "date",
    },
    size: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    inlineStyle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    };
  },
  computed: {
    pickerValue: {
      get() {
        if (this.value) {
          if (Array.isArray(this.value)) {
            return this.value.map((e) => this.addTimezone(e));
          }
          return this.addTimezone(this.value);
        }
        return this.value;
      },
      set(val) {
        if (val) {
          Array.isArray(val)
            ? (val = val.map((e) => this.removeTimezone(e)))
            : (val = this.removeTimezone(val));
        }

        this.$emit("input", val);
      },
    },
  },
  methods: {
    addTimezone(date) {
      return Date.parse(date) + userTimezone;
    },
    removeTimezone(date) {
      return new Date(Date.parse(date) - userTimezone);
    },
  },
};
</script>
